export default __webpack_public_path__ + "static/media/familia.aef12f1f.png";